import { Button, DrawerRight, Loading, TextField } from 'src/components';
import { type ChangeEvent, useEffect } from 'react';
import {
	Grid,
	InputLabel,
	MenuItem,
	TextField as MuiTexField,
	Select,
} from '@material-ui/core';
import { useFormik, validateYupSchema } from 'formik';

import { type IUser } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import { userTypes } from 'src/helpers/constants';
import institutionActions from 'src/store/Institutions/actions';
import userActions from 'src/store/Users/actions';

interface Props {
	open: boolean;
	onClose: () => void;
	userId?: string;
}

function UserDrawerForm({ onClose, open, userId }: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const { isLoadingOne, user } = useSelector(
		(state: RootState) => state.users,
	);
	const { institution, institutions } = useSelector(
		(state: RootState) => state.institutions,
	);
	const getInstitutions = () => dispatch(institutionActions.getAll());
	const create = (user: IUser) => dispatch(userActions.create(user));
	const update = (user: IUser) => dispatch(userActions.update(user));
	const getOne = (id: string) => dispatch(userActions.getOne(id));
	const clearUser = () => dispatch(userActions.setOne({}));

	const { handleChange, handleReset, handleSubmit, values } = useFormik({
		enableReinitialize: true,
		initialValues: userId
			? user
			: {
				department: '',
				email: '',
				firstname: '',
				institutionId: '',
				lastname: '',
				password: '',
				type: userTypes.USER,
				username: '',
			},
		onSubmit: (values) => {
			if (userId) update(values);
			else create(values);
			onClose();
		},
	});

	useEffect(() => {
		if (open) {
			if (userId) getOne(userId);
		} else {
			handleReset({});
			clearUser();
		}
	}, [open, userId]);

	function handleSelectChange(
		event: ChangeEvent<{
			name?: string | undefined;
			value: unknown;
		}>,
	) {
		const { value } = event.target;

		if (value !== userTypes.ADMIN) {
			getInstitutions();
		}

		handleChange(event);
	}

	return (
		<DrawerRight
			onClose={onClose}
			open={open}
			title={`${userId ? 'Editar' : 'Agregar'} Usuario`}
		>
			<Loading isLoading={isLoadingOne}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<InputLabel>Tipo</InputLabel>

						<Select
							fullWidth
							name={'type'}
							onChange={handleSelectChange}
							value={values.type || userTypes.USER}
							variant={'outlined'}
						>
							<MenuItem value={userTypes.ADMIN}>
								Administrador
							</MenuItem>

							<MenuItem value={userTypes.INSTITUTION}>
								Institución
							</MenuItem>

							<MenuItem value={userTypes.USER}>Usuario</MenuItem>
						</Select>
					</Grid>

					{values.type == userTypes.INSTITUTION ||
						values.type === userTypes.USER ? (
						<Grid item xs={12}>
							<InputLabel>Institución</InputLabel>

							<Select
								fullWidth
								name={'institutionId'}
								onChange={handleChange}
								value={values.institutionId || ''}
								variant={'outlined'}
							>
								{institutions.map(
									(institution: any, index: number) => (
										<MenuItem
											key={index}
											value={institution.id}
										>
											{institution.name}
										</MenuItem>
									),
								)}
							</Select>
						</Grid>
					) : null}

					<Grid item xs={12}>
						<TextField
							label={'Usuario'}
							name={'username'}
							onChange={handleChange}
							value={values.username}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Password'}
							name={'password'}
							onChange={handleChange}
							value={values.password}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Email'}
							name={'email'}
							onChange={handleChange}
							value={values.email}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Nombre(s)'}
							name={'firstname'}
							onChange={handleChange}
							value={values.firstname}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Apellidos'}
							name={'lastname'}
							onChange={handleChange}
							value={values.lastname}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Departamento'}
							name={'department'}
							onChange={handleChange}
							value={values.department}
						/>
					</Grid>

					<Grid item xs={12}>
						<Button
							actionType={'save'}
							fullWidth
							onClick={() => {
								handleSubmit();
							}}
						>
							{userId ? 'Guardar Cambios' : 'Crear'}
						</Button>
					</Grid>
				</Grid>
			</Loading>
		</DrawerRight>
	);
}

export default UserDrawerForm;
